module.exports = __webpack_public_path__ + "static/media/print.f99cce21.svg";